__turbopack_context__.v({
  "section-header-with-description__descriptions": "szeXkG_section-header-with-description__descriptions",
  "section-header-with-description__eyebrow": "szeXkG_section-header-with-description__eyebrow",
  "section-header-with-description__img": "szeXkG_section-header-with-description__img",
  "section-header-with-description__separator": "szeXkG_section-header-with-description__separator",
  "section-header-with-description__title": "szeXkG_section-header-with-description__title",
});
